import { getIsChildAutomation } from 'pages/Automations/hooks';
import { AutomationDraft } from 'pages/Automations/types/AutomationDraft';
import { WorkflowEvent } from 'shared/types/graphql';

enum FieldNames {
  SendTiming = 'sendTiming',
  SendConditions = 'sendConditions',
  SendHours = 'sendHours',
  SendFrequency = 'sendFrequency',
  RequestOptions = 'requestOptions',
  Forms = 'forms',
  LinkedAutomations = 'linkedAutomations',
  NotifcationBody = 'notificationBody',
  LapsedConditions = 'lapsedConditions',
}

export function getVisibleAutomationFields({
  automationType,
  triggerType,
}: Pick<AutomationDraft, 'automationType' | 'triggerType'>): Record<FieldNames, boolean> {
  const isChildAutomation = getIsChildAutomation({ automationType, triggerType });

  return {
    sendTiming:
      (automationType === WorkflowEvent.AppointmentFollowup ||
        automationType === WorkflowEvent.AppointmentClientArrival ||
        automationType === WorkflowEvent.AppointmentConfirmReminder ||
        automationType === WorkflowEvent.AppointmentReminder) &&
      !isChildAutomation,
    sendConditions:
      (automationType === WorkflowEvent.AppointmentFollowup ||
        automationType === WorkflowEvent.AppointmentPimsSync ||
        automationType === WorkflowEvent.AppointmentClientArrival ||
        automationType === WorkflowEvent.AppointmentConfirmReminder ||
        automationType === WorkflowEvent.AppointmentReminder ||
        automationType === WorkflowEvent.AppointmentScheduled) &&
      !isChildAutomation,
    sendHours:
      (automationType === WorkflowEvent.AppointmentFollowup ||
        automationType === WorkflowEvent.AppointmentPimsSync ||
        automationType === WorkflowEvent.AppointmentClientArrival ||
        automationType === WorkflowEvent.AppointmentConfirmReminder ||
        automationType === WorkflowEvent.AppointmentReminder ||
        automationType === WorkflowEvent.AppointmentScheduled ||
        automationType === WorkflowEvent.LapsedPetParent) &&
      !isChildAutomation,
    sendFrequency:
      (automationType === WorkflowEvent.AppointmentFollowup ||
        automationType === WorkflowEvent.AppointmentPimsSync ||
        automationType === WorkflowEvent.AppointmentClientArrival ||
        automationType === WorkflowEvent.AppointmentReminder ||
        automationType === WorkflowEvent.AppointmentScheduled) &&
      !isChildAutomation,
    requestOptions: automationType === WorkflowEvent.WidgetRequestFormSubmitted,
    forms: automationType === WorkflowEvent.CallDeflectionFormSubmitted,
    linkedAutomations: isChildAutomation,
    lapsedConditions: automationType === WorkflowEvent.LapsedPetParent,
    notificationBody:
      automationType !== WorkflowEvent.CallDeflectionFormSubmitted &&
      automationType !== WorkflowEvent.ServiceReminderFormSubmitted &&
      !isChildAutomation,
  };
}
